import React from 'react';
import _ from 'underscore';

import {displayPath} from 'registry/field/FieldPathUtil';
import {SchemaFieldEdge, SchemaFieldPath} from 'schemas/fields/SchemaFieldConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface HoistedTagNameBadgeProps {
  tagSchemaGraph: SchemaFieldPath;
}

function _tagSchemaGraphToOrderedPath(tagSchemaGraph: SchemaFieldPath): Array<SchemaFieldEdge> {
  // Assume `edges` are ordered and a forward path. Divide them into `orderedPath` (everything but the last
  // field) and `hoistedField` (the last field).
  //
  // TODO(T10276): Refactor into a method shared between `HoistedTagNameBadge` and hoisted fields table.
  // eslint-disable-next-line no-restricted-syntax
  return _.initial(tagSchemaGraph.edges);
}

export default function HoistedTagNameBadge(props: HoistedTagNameBadgeProps): React.ReactElement {
  const orderedPath = _tagSchemaGraphToOrderedPath(props.tagSchemaGraph);
  const firstEdge = orderedPath[0];
  const sourceTagSchemaId = firstEdge?.from?.id;

  return (
    <span className="u-no-wrap">
      <Tooltip
        title={sourceTagSchemaId ? displayPath({sourceTagSchemaId, tagSchemaFieldEdges: orderedPath}) : ''}
      >
        <span>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_BLUE}
            className="u-no-mouse-target"
            size={ButtonSize.MINI}
            text="Hoisted"
          />
        </span>
      </Tooltip>
    </span>
  );
}
